module.exports = __webpack_public_path__ + "4332fcbc4ca7fa5c4ed7450af4df2c18.pdf";